// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"CardWithBadge_cardWrap__3uI1P","cardBadge":"CardWithBadge_cardBadge__3U18G"};